export { deepMergeSpec } from "@json-render/core";
